import { HierarchyKey, SearchCriteriaKey, SearchCriterion } from "./criteria";
import { ProductType } from "./productType";

// These types are not final
export type InstanceType = string
export const INSTANCE_OWNERSHIP_ENTITY = 'INSTANCE_OWNERSHIP_ENTITY'
export const INSTANCE_OWNERSHIP_SUBENTITY = 'INSTANCE_OWNERSHIP_SUBENTITY'
export const INSTANCE_AGENCY = 'INSTANCE_AGENCY'
export const INSTANCE_BRAND = 'INSTANCE_BRAND'
export const INSTANCE_COMPANY = 'INSTANCE_COMPANY' // includes POST SMB companies/Stripe account

export const INSTANCE_REGION = 'INSTANCE_REGION'
export const INSTANCE_CLUSTER = 'INSTANCE_CLUSTER'
export const INSTANCE_MARKET = 'INSTANCE_MARKET' // POSTV2 calls this region

export const INSTANCE_CLUSTER_REGION = 'INSTANCE_CLUSTER_REGION'
export const INSTANCE_STATION_FACILITY = 'INSTANCE_STATION_FACILITY'
export const INSTANCE_STATION = 'INSTANCE_STATION'
export const INSTANCE_STATION_STREAM = 'INSTANCE_STATION_STREAM'

export type UserInstanceLevel = string
export const USER_INSTANCE_LEVEL_OWNERSHIP_ENTITY = 'USER_INSTANCE_LEVEL_OWNERSHIP_ENTITY'
export const USER_INSTANCE_LEVEL_OWNERSHIP_SUBENTITY = 'USER_INSTANCE_LEVEL_OWNERSHIP_SUBENTITY'
export const USER_INSTANCE_LEVEL_COMPANY = 'USER_INSTANCE_LEVEL_COMPANY'
export const USER_INSTANCE_LEVEL_REGION = 'USER_INSTANCE_LEVEL_REGION'
export const USER_INSTANCE_LEVEL_MARKET = 'USER_INSTANCE_LEVEL_MAKRET'
export const USER_INSTANCE_LEVEL_STATION = 'USER_INSTANCE_LEVEL_STATION'

export interface ProductInstanceResult {
    product: ProductType
    instanceType?: InstanceType
    instanceId: string
    name: string
    company?: string
    icon?: string
    description?: string
    criteria: SearchCriterion[]
    hierarchy?: HierarchyKey[]
    redirectUrl?: string
}

export type ProductInstanceCriteriaKeys = Record<ProductType, SearchCriteriaKey[]>

export interface ProductInstancesResult {
    instances: ProductInstanceResult[]
    criteriaKeys?: SearchCriteriaKey[]
}
